import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService} from "../../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {TagService} from "../../../../shared/services/tag.service";
import {delay, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {Uuid} from "../../../../shared/interface/response/uuid";

@Component({
  selector: 'app-permission-tags-add',
  templateUrl: './permission-tags-add.component.html',
  styleUrls: ['./permission-tags-add.component.scss']
})
export class PermissionTagsAddComponent implements OnInit, OnDestroy, AfterViewInit {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() tag?: PermissionsTag;
  @Input() mod = false;
  @Output() closeModification = new EventEmitter<any>();

  tagForm: FormGroup;
  typeControl: FormControl;
  nameControl: FormControl;
  activeControl: FormControl;
  tagsFormValid = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private permissionTagsService: PermissionTagsService,

  ) {
    this.tagForm = fb.group({
      id: fb.control(''),
      active: this.activeControl = this.fb.control(''),
      name: this.nameControl = this.fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.tagForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.tagsFormValid = this.tagForm.valid);
  }

  ngAfterViewInit(): void {
    if (this.tag) {
      this.initialize(this.tag);
    } else {
      this.initialized.next(true);
    }
  }



  initialize(tag: PermissionsTag): void {
    of(tag)
      .pipe(
        delay(0),
        tap(() => {
          this.tagForm.reset({
            id: tag.id,
            name: tag.name,
            active: tag.active,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (!this.tag) {
      this.router.navigate(['/asf360/tagi-uprawnienia']);
    } else {
      this.closeModification.emit();
    }
  }

  sendForm(): void {
    this.permissionTagsService.send(this.tagForm.value)
      .subscribe((response) => {
        this.snack.open(this.tag ? 'Pomyślnie zaktualizowano grupę uprawnień' : 'Pomyślnie dodano grupę uprawnień.', '', {
          duration: 2000,
        });
        if (this.tag) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/asf360/tagi-uprawnienia']);

          // this.router.navigate(['/asf360/tagi-uprawnienia/szczegoly', response.id]);
        }
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania grupę uprawnień wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }

}
